import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function Hero() {
  return <section className="pt-6 pb-4 px-4 sm:px-6 bg-white text-center border-b-4 border-brand-beige" data-id="element-82">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-gold/10 border border-brand-gold/30 text-brand-taupe font-bold text-xs sm:text-sm mb-2 shadow-sm" data-id="element-83">
        <span data-id="element-84">✨</span>
        <span className="tracking-wide" data-id="element-85">SISTEMA DI DANZA VALIDATO</span>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-brand-taupe leading-none mb-2" data-id="element-86">
        Il Sistema Completo di Pianificazione per Insegnanti di Danza
      </h1>

      <p className="text-base sm:text-lg text-brand-taupe/80 font-semibold leading-tight mb-4 max-w-2xl mx-auto" data-id="element-87">
        Risparmia ore di preparazione, organizza lezioni professionali e fai
        crescere i tuoi allievi con un metodo già pronto all'uso.
      </p>

      <div className="inline-block bg-brand-rose text-white px-4 py-1 rounded-md mb-2 shadow-md" data-id="element-88">
        <p className="font-button font-bold text-sm sm:text-base tracking-wide" data-id="element-89">
          🩰 DANZA READY™ — Box Set Completo 6 in 1
        </p>
      </div>

      <div className="mb-4" data-id="element-90">
        <a href="https://dance-pro.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-91">
          <img src="https://cdn.magicpatterns.com/uploads/6PKu3wnxFsSvqguc9Xmwz5/ChatGPT_Image_10_jul_2026,_09_16_51_p.m..png" alt="Danza Ready - Box Set Completo 6 in 1" className="w-full h-auto object-contain max-w-[280px] sm:max-w-sm mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-xl" data-id="element-92" />
        </a>
      </div>

      <div className="mb-3" data-id="element-93">
        <CTAButton data-id="element-94">🚀 SÌ, VOGLIO IL MIO SISTEMA ORA</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-4 text-xs sm:text-sm text-brand-taupe font-bold" data-id="element-95">
        <div className="flex items-center gap-1" data-id="element-96">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-97" />
          <span data-id="element-98">4.9/5 — Recensioni Professionali Verificate</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-99">
          <Shield className="w-4 h-4 text-brand-rose" data-id="element-100" />
          <span data-id="element-101">Garanzia 7 Giorni — Zero Rischio</span>
        </div>
      </div>
    </section>;
}